import React, { useContext, useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Link,
  Icon,
  Divider,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaTelegram } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { AppContext } from '../context/AppContext';

const MotionVStack = motion(VStack);
const MotionBox = motion(Box);

const TelegramModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { userEmail } = useContext(AppContext);
  useEffect(() => {
    if (!userEmail) return;
    const lastShownDate = localStorage.getItem(`telegram_modal_last_shown_${userEmail}`);
    const today = new Date().toDateString();

    if (lastShownDate !== today) {
      setIsOpen(true);
    }
  }, [userEmail]);

  const handleClose = () => {
    if (!userEmail) return;
    const today = new Date().toDateString();
    localStorage.setItem(`telegram_modal_last_shown_${userEmail}`, today);
    setIsOpen(false);
    window.location.href = "https://telegram.me/dailynewupdatepro";
  };

  const handleFollowClick = () => {
    // You can add logic here if you want to track the click before closing
  };

  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'white');

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
      },
    },
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="xl" isCentered>
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent bg={bgColor} color={textColor} borderRadius="xl">
        <ModalHeader textAlign="center">Connect With Us</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <MotionVStack
            spacing={3}
            align="stretch"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {/* English Section */}
            <MotionBox variants={itemVariants}>
              <Text fontWeight="bold" fontSize="md" mb={1}>
                Hello!
              </Text>
              <Text fontSize="sm">
                We’ve introduced a new Telegram channel, and it’s crucial for all users to join. All key updates, announcements, and valuable information will be shared there. We highly encourage you to subscribe so you stay fully up to date in a timely manner. Your engagement is greatly appreciated.
              </Text>
            </MotionBox>

            <MotionBox variants={itemVariants}>
              <Divider />
            </MotionBox>

            {/* Hindi Section */}
            <MotionBox variants={itemVariants}>
              <Text fontWeight="bold" fontSize="md" mb={1}>
                नमस्ते!
              </Text>
              <Text fontSize="sm">
                हमारा एक नया टेलीग्राम चैनल है, जो हमारे प्लेटफ़ॉर्म और वेबसाइट से सीधे जुड़ा हुआ है। सभी महत्वपूर्ण अपडेट, घोषणाएँ और उपयोगी जानकारी वहीं मिलेगी। इसलिए, सभी उपयोगकर्ताओं के लिए इसे जॉइन करना बेहद ज़रूरी है, ताकि आप समय पर पूरी जानकारी पाएँ। आपका सहयोग और सक्रियता हमारे लिए बहुमूल्य है।
              </Text>
            </MotionBox>

            {/* Combined Call to Action */}
            <MotionBox textAlign="center" pt={1} variants={itemVariants}>
              <Text fontSize="sm" fontWeight="semibold">
                Join our Telegram channel for the latest updates. <Link href="https://telegram.me/dailynewupdatepro" isExternal color="blue.500" onClick={handleFollowClick}>Click here!</Link>
              </Text>
              <Text fontSize="sm" fontWeight="semibold" mt={1}>
                नवीनतम अपडेट के लिए हमारे टेलीग्राम चैनल से जुड़ें। <Link href="https://telegram.me/dailynewupdatepro" isExternal color="blue.500" onClick={handleFollowClick}>Click here!</Link>
              </Text>
              <Link href="https://telegram.me/dailynewupdatepro" isExternal onClick={handleFollowClick} display="inline-block" mt={2}>
                <MotionBox
                  display="inline-block"
                  whileHover={{ scale: 1.2, rotate: 10 }}
                  animate={{
                    scale: [1, 1.1, 1],
                    rotate: [0, 5, -5, 0],
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                >
                  <Icon as={FaTelegram} w={10} h={10} color="blue.500" />
                </MotionBox>
              </Link>
            </MotionBox>
          </MotionVStack>
        </ModalBody>

        <ModalFooter justifyContent="center">
          <Button colorScheme="blue" onClick={handleClose} size="lg" w="full">
            OK, i Joined
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TelegramModal;
